"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Selection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_dom_1 = require("react-dom");
const useSelection_1 = require("./hooks/useSelection");
const Selection = ({ containerRef, selectableRefs, onSelectedChange, canSelect }) => {
    const { box, mouseDown } = (0, useSelection_1.useSelection)({
        containerRef,
        selectableRefs,
        onSelectedChange,
        canSelect
    });
    if (!mouseDown || !box)
        return null;
    return (0, react_dom_1.createPortal)((0, jsx_runtime_1.jsx)("div", { className: "selection__box", style: box }, void 0), document.body);
};
exports.Selection = Selection;
//# sourceMappingURL=Selection.js.map